import { createContext } from 'react';
export const CustomizerContext = createContext(null);
